import { ImportOutlined, UploadOutlined } from "@ant-design/icons";
import { Alert, Button, GetProp, Modal, Spin, Upload, UploadFile } from "antd";
import { UploadProps } from "antd/lib";
import { useState } from "react";
import { useMutation } from "react-query";

interface PropsImportBtn {
  multiple?: boolean;
  block?: boolean;
  uploadFunction: (formData: FormData) => void;
  onSuccess?: () => void;
  onError?: () => void;
}

type FileType = Parameters<GetProp<UploadProps, "beforeUpload">>[0];

export default function ImportBtn({
  multiple = false,
  block = false,
  uploadFunction,
  onSuccess,
  onError,
}: PropsImportBtn) {
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");

  const props: UploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setFileList([...fileList, file]);

      return false;
    },
    fileList,
    multiple,
  };

  const { mutate: importMutate, isLoading: uploading } = useMutation<
    unknown,
    unknown,
    FormData
  >(
    async (formData: FormData) => {
      return uploadFunction(formData);
    },
    {
      onSuccess: () => {
        setFileList([]);
        closeModal();
        if (onSuccess) onSuccess();
      },
      onError: () => {
        setFileList([]);
        closeModal();
        if (onError) onError();
      },
    }
  );

  const handleUpload = () => {
    const formData = new FormData();

    if (multiple) {
      fileList.forEach((file) => {
        formData.append("files[]", file as FileType);
      });
    } else {
      fileList.forEach((file) => {
        formData.append("file", file as FileType);
      });
    }

    if (errorMessage) setErrorMessage("");

    importMutate(formData);
  };

  const closeModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      <Button
        type="link"
        className="show_result_size"
        style={{ paddingRight: 24 }}
        onClick={() => setOpenModal(true)}
        block={block}
      >
        <ImportOutlined /> Importar
      </Button>

      <Modal
        title="Importar dados"
        open={openModal}
        maskClosable={true}
        closeIcon={true}
        footer={null}
        width={582}
        style={{ top: 20 }}
        styles={{ body: { padding: "12px 8px" } }}
        onCancel={closeModal}
      >
        {errorMessage && (
          <Alert
            message={errorMessage}
            type="error"
            className="alertMessage"
            showIcon
            closable
            onClose={() => setErrorMessage("")}
          />
        )}

        <Upload {...props}>
          <Button
            icon={<UploadOutlined />}
            disabled={!multiple && fileList.length > 0}
          >
            Selecionar arquivo
          </Button>
        </Upload>

        <Button
          type="primary"
          onClick={handleUpload}
          disabled={!fileList.length}
          loading={uploading}
          style={{ marginTop: 16 }}
        >
          {uploading ? "Importando..." : "Iniciar importação"}
        </Button>
      </Modal>
    </>
  );
}
